import { render, staticRenderFns } from "./cookieSetting.vue?vue&type=template&id=5ef17544&scoped=true&"
import script from "./cookieSetting.vue?vue&type=script&lang=js&"
export * from "./cookieSetting.vue?vue&type=script&lang=js&"
import style0 from "./cookieSetting.vue?vue&type=style&index=0&id=5ef17544&prod&lang=less&scoped=true&"
import style1 from "./cookieSetting.vue?vue&type=style&index=1&id=5ef17544&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef17544",
  null
  
)

export default component.exports